import { Fragment, memo } from 'react';
import { cn } from '@divlab/divanui';

import Sizes from './elements/Sizes';
import styles from './PartsTable.module.css';

import type { PartData } from '@Pages/PageProduct';
import type { FC, HTMLAttributes } from 'react';

export interface PartsTableProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  parts: PartData[];
}

const PartsTable: FC<PartsTableProps> = (props) => {
  const { className, parts, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.table, className)}>
      {parts.map((part, index) => (
        <div key={index} className={styles.row}>
          <div className={styles.header}>{part.name}</div>
          <div className={styles.parameters}>
            {part.parameters.map((parameter, idx) => (
              <Fragment key={idx}>
                <div className={cn(styles.cell, styles.parameterName)}>{parameter.name}</div>
                <div className={styles.cell}>
                  {(() => {
                    if (parameter.theme === 'text') {
                      return parameter.value;
                    }

                    if (parameter.theme === 'dimensions') {
                      return <Sizes sizes={parameter.value} />;
                    }
                  })()}
                </div>
              </Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(PartsTable);
